import { 
  IconButton, 
  Menu, 
  MenuItem, 
  ListItemIcon, 
  ListItemText,
  useTheme 
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useState } from 'react';
import type { ReactNode } from 'react';

export interface ActionMenuItem {
  label: string;
  icon: ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

interface ActionMenuProps {
  items: ActionMenuItem[];
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

export function ActionMenu({ 
  items, 
  size = 'small', 
  color 
}: ActionMenuProps) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (item: ActionMenuItem) => {
    if (!item.disabled) {
      item.onClick();
      handleMenuClose();
    }
  };

  return (
    <>
      <IconButton
        size={size}
        onClick={handleMenuOpen}
        sx={{ 
          color: color || theme.palette.text.secondary 
        }}
      >
        <MoreVertIcon fontSize={size} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {items.map((item, index) => (
          <MenuItem 
            key={index}
            onClick={() => handleItemClick(item)}
            disabled={item.disabled}
          >
            <ListItemIcon>
              {item.icon}
            </ListItemIcon>
            <ListItemText>{item.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
} 